import { render, staticRenderFns } from "./Marking.vue?vue&type=template&id=7608e442&scoped=true"
import script from "./Marking.vue?vue&type=script&lang=js"
export * from "./Marking.vue?vue&type=script&lang=js"
import style0 from "./Marking.vue?vue&type=style&index=0&id=7608e442&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7608e442",
  null
  
)

export default component.exports